"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    r = require("react-spring");

function t() {
  return (t = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];

      for (var n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var n = {
  dark: {
    circle: {
      r: 9
    },
    mask: {
      cx: "50%",
      cy: "23%"
    },
    svg: {
      transform: "rotate(40deg)"
    },
    lines: {
      opacity: 0
    }
  },
  light: {
    circle: {
      r: 5
    },
    mask: {
      cx: "100%",
      cy: 0
    },
    svg: {
      transform: "rotate(90deg)"
    },
    lines: {
      opacity: 1
    }
  },
  springConfig: {
    mass: 4,
    tension: 250,
    friction: 35
  }
};
exports.DarkModeSwitch = function (i) {
  var o = i.onChange,
      l = i.checked,
      c = void 0 !== l && l,
      s = i.size,
      a = void 0 === s ? 24 : s,
      g = i.animationProperties,
      y = void 0 === g ? n : g,
      m = i.moonColor,
      u = void 0 === m ? "white" : m,
      f = i.sunColor,
      d = void 0 === f ? "black" : f,
      p = i.style,
      x = function (e, r) {
    if (null == e) return {};
    var t,
        n,
        i = {},
        o = Object.keys(e);

    for (n = 0; n < o.length; n++) {
      r.indexOf(t = o[n]) >= 0 || (i[t] = e[t]);
    }

    return i;
  }(i, ["onChange", "children", "checked", "size", "animationProperties", "moonColor", "sunColor", "style"]),
      h = e.useMemo(function () {
    return y !== n ? Object.assign(n, y) : y;
  }, [y])[c ? "dark" : "light"],
      k = h.circle,
      v = h.lines,
      C = h.mask,
      E = r.useSpring(t({}, h.svg, {
    config: y.springConfig
  })),
      w = r.useSpring(t({}, k, {
    config: y.springConfig
  })),
      b = r.useSpring(t({}, C, {
    config: y.springConfig
  })),
      O = r.useSpring(t({}, v, {
    config: y.springConfig
  }));

  return e.createElement(r.animated.svg, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    color: c ? u : d,
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor",
    onClick: function onClick() {
      o(!c);
    },
    style: t({
      cursor: "pointer"
    }, E, p)
  }, x), e.createElement("mask", {
    id: "myMask2"
  }, e.createElement("rect", {
    x: "0",
    y: "0",
    width: "100%",
    height: "100%",
    fill: "white"
  }), e.createElement(r.animated.circle, {
    style: b,
    r: "9",
    fill: "black"
  })), e.createElement(r.animated.circle, {
    cx: "12",
    cy: "12",
    fill: c ? u : d,
    style: w,
    mask: "url(#myMask2)"
  }), e.createElement(r.animated.g, {
    stroke: "currentColor",
    style: O
  }, e.createElement("line", {
    x1: "12",
    y1: "1",
    x2: "12",
    y2: "3"
  }), e.createElement("line", {
    x1: "12",
    y1: "21",
    x2: "12",
    y2: "23"
  }), e.createElement("line", {
    x1: "4.22",
    y1: "4.22",
    x2: "5.64",
    y2: "5.64"
  }), e.createElement("line", {
    x1: "18.36",
    y1: "18.36",
    x2: "19.78",
    y2: "19.78"
  }), e.createElement("line", {
    x1: "1",
    y1: "12",
    x2: "3",
    y2: "12"
  }), e.createElement("line", {
    x1: "21",
    y1: "12",
    x2: "23",
    y2: "12"
  }), e.createElement("line", {
    x1: "4.22",
    y1: "19.78",
    x2: "5.64",
    y2: "18.36"
  }), e.createElement("line", {
    x1: "18.36",
    y1: "5.64",
    x2: "19.78",
    y2: "4.22"
  })));
}, exports.defaultProperties = n;